import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  ModuleStateSummary,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/actions`;

export interface GetFileActionsQueryArgs {
  fileId: string;
}

export const getFileActionsRequest = (
  payload: GetFileActionsQueryArgs,
): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, payload.fileId),
  config: { method: SUPPORTED_METHODS.GET },
});

const getFileActionsQuery = async (
  payload: GetFileActionsQueryArgs,
): Promise<BackResponse<ModuleStateSummary[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<ModuleStateSummary[]>>(
      getFileActionsRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default getFileActionsQuery;
